module.exports = __webpack_public_path__ + "static/media/IIh.3260ec92.jpg";